import { render } from "./StudyOpenHoursDetail.vue?vue&type=template&id=f18c6ba6"
import script from "./StudyOpenHoursDetail.vue?vue&type=script&lang=js"
export * from "./StudyOpenHoursDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__